// extracted by mini-css-extract-plugin
export default {"list":"orders_list__6ibU6"};